module.exports = {"id":"233329","name":"Mikel Villanueva","rating":"74","photo":"./data/images/photos/1/233329.png","club":{"name":"Cádiz C.F.","logo":"./data/images/clubs/CadizC.F..png"},"positions":["DC"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/MikelVillanueva0.json
// module id = 3027
// module chunks = 0